<template>
    <common-modal :width="'medium'" @emitEvent="emitEvent($event, ['close'])" @close="goToIndex()">
        <common-content-spacer height="medium">
            <header>
                <common-icon name="bell" size="gigantic"></common-icon>
                <p>{{ $t('pages.practice.profile.locations_modal.set_availability') }}</p>
            </header>

            <footer>
                <common-buttons>
                    <common-button
                        :label="$t('pages.practice.profile.locations_modal.no')"
                        type="secondary"
                        size="large"
                        @click="goToIndex()"
                    ></common-button>
                    <common-button
                        :label="$t('pages.practice.profile.locations_modal.yes')"
                        type="primary"
                        size="large"
                        @click="goToAvailabity()"
                    ></common-button>
                </common-buttons>
            </footer>
        </common-content-spacer>
    </common-modal>
</template>

<script>
    export default {
        components: {},

        props: {
            firstNewLocationId: { type: Number, require: true, default: null },
        },

        methods: {
            goToIndex() {
                this.$auth.isPracticeAncillary()
                    ? this.$router.push({ name: 'practice.profile-ancillary' })
                    : this.$router.push({ name: 'practice.profile' })
            },

            goToAvailabity() {
                // Land on the calendar (empty state for a location without a
                // schedule) with the Manage Availability modal opened for it.
                this.$router.push({
                    name: 'availability',
                    params: { action: 'schedule' },
                    query: { locationId: this.firstNewLocationId, manage: '1' },
                })
            },
        },
    }
</script>

<style lang="scss" scoped>
    @import 'styles/setup/_variables.scss';

    header {
        text-align: center;

        .notification-icon {
            min-width: 35px;
            z-index: 1;
            position: relative;
            padding-bottom: 30px;
        }

        p {
            font-size: $font-size--header-copy;
            color: $color--txt-base-2;
            word-spacing: 0.01em;
        }
    }

    main {
        .appointment_date {
            display: flex;
            justify-content: center;
        }

        h4 {
            font-family: Poppins;
            font-size: 22px;
            text-align: center;
            margin-bottom: 1rem;
            color: $color--txt-base-6;
            padding-top: 30px;
        }
    }

    footer {
        text-align: center;
    }
</style>
